import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import validator from 'validator'

import Hidden from '@material-ui/core/Hidden'
import { makeStyles } from '@material-ui/core/styles'

import { Alert, AlertTitle } from '@material-ui/lab'

import { useApplicationApiRequest } from '../hooks/useApplicationApi'

import TeamInfo from './TeamInfo'

import footerImage from '../../assets/images/footer.jpg'

function getLatestReport(reports) {
  const sortedReports = reports.sort((a, b) => b.id - a.id)

  const [report] = sortedReports

  return report
}

const styles = (theme) => ({
  card: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  heading: {
    backgroundColor: theme.palette.primary.light,
    color: '#ffffff',
  },
  headingExpandIcon: {
    color: '#ffffff',
  },
  headingTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  content: {
    padding: 0,
  },
  alertBlock: {
    flex: 1,
  },
  divider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  poweredByContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  poweredByLogos: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  poweredByLogo: {
    margin: theme.spacing(1),
  },
  spacing: {
    width: '32px',
  },
})
const useStyles = makeStyles(styles)

export default function TeamContainer(props) {
  const { authorizationToken, invalidateAuthorizationToken, teamNumber } = props

  const apiRequest = useApplicationApiRequest(
    `/hackathon/hackpelofuturo/team/${teamNumber}`,
    {
      headers: {
        Authorization: `Bearer ${authorizationToken}`,
      },
    },
  )
  const { error, isLoading, response } = apiRequest

  const classes = useStyles()

  if (isLoading) {
    throw Promise.resolve(null)
  }

  if (error) {
    if (error.response.status === 401) {
      invalidateAuthorizationToken()
      return null
    }

    return (
      <Alert severity="error">
        <AlertTitle>Oops!</AlertTitle>
        Não foi possível carregar os dados da equipe.
        <br />
        Por favor, verifique se o link está correto e tente novamente.
      </Alert>
    )
  }

  if (!response) {
    return null
  }

  const teamReports = response.data

  const { final = [] } = teamReports

  const reportFinal = getLatestReport(final)

  const teamMembersNames = reportFinal
    ? [
        reportFinal.applicant_name,
        reportFinal.applicant_b_name,
        reportFinal.applicant_c_name,
        reportFinal.applicant_d_name,
        reportFinal.applicant_e_name,
        reportFinal.applicant_f_name,
        ...(reportFinal.applicant_others ?? '')
          .split('\n')
          .map((applicant) => applicant.replace(/<.*>/g, '')),
      ]
        .filter((teamMember) => teamMember && !validator.isEmpty(teamMember))
        .sort()
    : []

  return (
    <Fragment>
      {!!reportFinal && (
        <TeamInfo
          authorizationToken={authorizationToken}
          deckId={reportFinal ? reportFinal.deck_id : null}
          projectCategory={reportFinal ? reportFinal.report_category : null}
          projectDataroom={reportFinal ? reportFinal.report_dataroom : ''}
          projectLearnings={reportFinal ? reportFinal.report_learnings : ''}
          projectMadlib={reportFinal ? reportFinal.report_madlib : ''}
          projectNextSteps={reportFinal ? reportFinal.report_next_steps : ''}
          projectProductMap={reportFinal ? reportFinal.report_product_map : ''}
          recordingId={reportFinal ? reportFinal.recording_id : null}
          teamMembersNames={teamMembersNames}
          teamName={reportFinal.team_name}
          teamNumber={teamNumber}
        />
      )}

      <br />

      <Hidden smDown>
        <div className={classes.poweredByContainer}>
          <div className={classes.poweredByLogos}>
            <img
              className={classes.poweredByLogo}
              alt="Realização"
              src={footerImage}
            />
          </div>
        </div>
      </Hidden>
    </Fragment>
  )
}

TeamContainer.propTypes = {
  authorizationToken: PropTypes.string.isRequired,
  invalidateAuthorizationToken: PropTypes.func.isRequired,
  teamNumber: PropTypes.number.isRequired,
}
